import { COLORS } from '@btime/constants'
import { capitalizeIfLower } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text, Title } from '../../../../components/presentation/Text'
import { getLastEvent, getReason } from '../../../../utils/helpers/events'
import Gallery from '../../../../components/presentation/gallery/Gallery'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'
import { Grid } from '../../../../packages/kiti/components/structure/Grid'

const StatusReasonPanel = ({ serviceOrder }) => {
  const { t } = useTranslation('serviceOrders')

  const reason = getReason(serviceOrder)
  const lastEvent = getLastEvent(serviceOrder.events)
  if (!reason) return false

  const { description, minicrudName, document, documents } = reason

  const documentOrDocuments = document ? [document] : documents
  const filteredDocuments = documentOrDocuments?.filter(document => document?.metadata?.['type'] !== 'signature') || []
  const signatures = documents?.filter(document => document?.metadata?.['type'] === 'signature') || []
  const signatureData = lastEvent?.signatureData

  const Section = ({ children }) => <div style={{ marginBottom: '1.5rem' }}>{children}</div>

  const MediaBlock = ({ title, items, signature }) => {
    if (!items || items.length === 0) return null

    return (
      <div style={{ marginBottom: '1rem' }}>
        <Title size="h6" style={{ marginBottom: '0.5rem' }}>
          {title}
        </Title>
        <Separator weight={1} />

        {signature && signatureData && (
          <Grid gap={0.5} align="center">
            <Text bold>{t('statusReason.name')}:</Text> {capitalizeIfLower(signatureData.name)}{' '}
            <Text bold>{t('statusReason.document')}:</Text> {signatureData.documentNumber}
          </Grid>
        )}

        <div
          style={{
            borderRadius: '6px'
          }}
        >
          <Gallery colWidth="30%" thumbHeight="8rem" items={items} />
        </div>
      </div>
    )
  }

  return (
    <Panel lineBorder mediumPadding>
      <Section>
        <Title size="h6">{t('statusReason.unproductiveReason')}</Title>
        <Text>{capitalizeIfLower(minicrudName)}</Text>

        {description && (
          <Text size="small" color={COLORS.dark3} preLine>
            {description}
          </Text>
        )}
      </Section>

      <MediaBlock title={t('statusReason.evidences')} items={filteredDocuments} />
      <MediaBlock title={t('statusReason.signature')} items={signatures} signature />
    </Panel>
  )
}

export default StatusReasonPanel
